import { Phone, FileText } from "lucide-react";
import { Link } from "react-router-dom";
import { COMPANY } from "@/lib/siteData";

export default function StickyCallBar() {
  return (
    <div
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-[#001B35] border-t border-white/10 grid grid-cols-2"
      data-testid="sticky-call-bar"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <a
        href={`tel:${COMPANY.phoneTel}`}
        data-testid="sticky-call"
        className="flex items-center justify-center gap-2 py-4 text-white bg-[#005BBB]"
      >
        <Phone className="w-4 h-4" /> Appeler
      </a>
      <Link
        to="/contact"
        data-testid="sticky-devis"
        className="flex items-center justify-center gap-2 py-4 text-white bg-[#D90000]"
      >
        <FileText className="w-4 h-4" /> Devis gratuit
      </Link>
    </div>
  );
}
